import Vue from 'vue'
import XEUtils from 'xe-utils'
import {
  VXETable,
  Icon,
  Header,
  Export,
  Modal,
  Button,
  Column,
  Tooltip,
  Toolbar,
  Table,
  Select,
  Pager,
} from 'vxe-table'
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import moment from 'moment'
// 导入默认的国际化（如果项目中使用多语言，则应该导入到 vue-i18n 中）
VXETable.setup({
  i18n: key => XEUtils.get(zhCN, key),
})
// 自定义全局的格式化处理函数
VXETable.formats.mixin({
  // 格式化下拉选项
  formatSelect({ cellValue }, list) {
    const item = list.find(item => item.value === cellValue)
    return item ? item.label : ''
  },
  // 格式化日期，默认 yyyy-MM-dd HH:mm:ss
  formatDate({ cellValue }, format) {
    return XEUtils.toDateString(cellValue, format || 'yyyy-MM-dd HH:mm:ss')
  },
  // 四舍五入金额，每隔3位逗号分隔，默认2位数
  formatAmount({ cellValue }, digits = 2) {
    return XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: digits })
  },
  // 格式化银行卡，默认每4位空格隔开
  formatBankcard({ cellValue }) {
    return XEUtils.commafy(XEUtils.toString(cellValue), { spaceNumber: 4, separator: ' ' })
  },
  // 四舍五入,默认两位数
  formatFixedNumber({ cellValue }, digits = 2) {
    if (!cellValue) {
      digits = 0
    }
    return XEUtils.toFixed(XEUtils.round(cellValue, digits), digits)
  },
  // 向下舍入,默认两位数
  formatCutNumber({ cellValue }, digits = 2) {
    return XEUtils.toFixed(XEUtils.floor(cellValue, digits), digits)
  },
  // 转换 moment 类型为字符串
  toMomentString({ cellValue }) {
    return cellValue ? moment(cellValue).format('YYYY-MM-DD hh:mm:ss') : ''
  },

  formatResult({ cellValue }) {
    if (!cellValue) {
      return '未生成'
    }
    return cellValue
  },
  salesFilterCode({ cellValue }) {
    let codeMap = {
      '01': '「标准销售出库单」日汇总',
      '02': '「赠品订单」日汇总',
      '03': '「京仓（京东自营）」日汇总',
      '04': '「FCS仓」日汇总',
      '05': '「一件代发业务（除也雅）」日汇总',
      '06': '「也雅代发仓出库」日汇总',
      '07': '「线下零售」日汇总',
      '08': '「样品出库」日汇总',
      '09': '「SA订单」日汇总',
      10: '「补发订单」日汇总',
      11: '「平台分销」日汇总',
      12: '「标准采购入库」',
      13: '「标准采购退货」',
      14: '「标准销售退货」',
      15: '「自用样品退货」',
      16: '「补发订单退货」',
      17: '「SA订单退货」',
      18: '「一件代发SA订单退货」',
      19: '「平台分销退货」',
      20: '「一件代发销售退货」',
      21: '「一件代发补发退货」',
      22: '「拆包出库」',
      23: '「盘亏单」',
      24: '「售后仓盘亏」',
      25: '「报损」',
      26: '「配件盘亏」',
      27: '「耗材盘亏」',
      28: '「配件组装」',
      29: '「拆包入库」',
      30: '「虚拟商品入库」',
      31: '「盘盈单」',
      32: '「售后盘盈」',
      33: '「样品盘盈入库」',
      35: '「配件盘盈」',
      37: '「一件代发SA」',
      38: '「一件代发补发」',
      39: '「一件代发样品」',
      45: '「差价链接」日汇总',
      46: '「收费配件补发」',
      47: '「库存调整」',
      48: '「样品盘亏」',
      49: '「FCS调拨」',
      50: '「样品入库」',
      51: '「调拨异常入库」',
      52: '「赠品入库」',
      53: '「跨境组销售」',
      54: '「标准销售出库单」差价链接',
    }

    console.log('salesFilterCode', cellValue)
    return codeMap[cellValue]
  },

  pushStatusFormatter({ cellValue }) {
    let codeMap = {
      0: '未写入',
      1: '写入中',
      2: '写入成功',
      3: '写入失败',
    }
    return codeMap[cellValue]
  },
})

// 先按需导入依赖的模块
Vue.use(Icon)
Vue.use(Header)
Vue.use(Column)
Vue.use(Tooltip)
Vue.use(Toolbar)
Vue.use(Button)
Vue.use(Export)
Vue.use(Modal)
Vue.use(Pager)
Vue.use(Select)
// 最后安装核心库
Vue.use(Table)



// WEBPACK FOOTER //
// ./src/plugins/table.js